import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { editMapping, selectCurrentMapping, selectPristineMapping, setEditorErrors } from "./mappingsSlice";
import { Editor } from "../../common/components/Editor";

export const MappingEditor = ({ header }) => {
  const [view, setView] = useState("edit");
  const { content = ''} = useSelector(selectCurrentMapping);
  const { content: pristineContent = ''} = useSelector(selectPristineMapping);

  const dispatch = useDispatch();
  const changeView = (data) => setView(data);

  const handleJsonChange = (value, event) => {
    var parsed = {};
    try {
      parsed = JSON.parse(value);
    } catch (error) {
      console.error(error);
      parsed = pristineContent;
    } finally {
      dispatch(
        editMapping({
          content: parsed,
        })
      );
    }
  };
  const handleEditorValidation = (markers) => {
   dispatch(setEditorErrors(markers));
  }
   
  return (
   <Editor
    header={header}
    view={view}
    setView={changeView}
    json={content}
    pristineJson={pristineContent}
    handleJsonChange={handleJsonChange}
    handleValidationErrors={handleEditorValidation}
   />
  );
};
